module.exports = __webpack_public_path__ + "img/US.507f7c31.png";